module.exports = __webpack_public_path__ + "static/media/telephone.c4e67a2e.svg";